import React, { useState } from 'react';
import { comments } from '../services/api';
import Avatar from './Avatar';
import '../styles/Comment.css';

const Comment = ({ comment, currentUserId, isAdmin, onUpdate, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(comment.content);
  const [loading, setLoading] = useState(false);

  const canEdit = currentUserId === comment.author._id;
  const canDelete = canEdit || isAdmin;

  const handleUpdate = async () => {
    if (!editContent.trim()) {
      alert('A komment nem lehet üres');
      return;
    }

    setLoading(true);
    try {
      const response = await comments.update(comment._id, editContent.trim());
      onUpdate(response.data);
      setIsEditing(false);
    } catch (error) {
      console.error('Update comment error:', error);
      alert('Hiba a komment frissítésekor');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Biztosan törölni szeretnéd ezt a kommentet?')) {
      return;
    }

    setLoading(true);
    try {
      await comments.delete(comment._id);
      onDelete(comment._id);
    } catch (error) {
      console.error('Delete comment error:', error);
      alert('Hiba a komment törlésekor');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('hu-HU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="comment">
      <div className="comment-header">
        <Avatar
          name={comment.author.name}
          imageUrl={comment.author.profileImage}
          size="small"
        />
        <div className="comment-meta">
          <span className="comment-author">{comment.author.name}</span>
          <span className="comment-date">
            {formatDate(comment.createdAt)}
            {comment.isEdited && <span className="edited-badge"> (szerkesztve)</span>}
          </span>
        </div>
        {(canEdit || canDelete) && (
          <div className="comment-actions">
            {canEdit && !isEditing && (
              <button
                onClick={() => setIsEditing(true)}
                className="btn-icon"
                title="Szerkesztés"
              >
                ✏️
              </button>
            )}
            {canDelete && (
              <button
                onClick={handleDelete}
                className="btn-icon"
                title="Törlés"
                disabled={loading}
              >
                🗑️
              </button>
            )}
          </div>
        )}
      </div>

      <div className="comment-body">
        {isEditing ? (
          <div className="comment-edit">
            <textarea
              value={editContent}
              onChange={(e) => setEditContent(e.target.value)}
              maxLength={1000}
              rows={3}
              className="comment-textarea"
            />
            <div className="comment-edit-actions">
              <button
                onClick={handleUpdate}
                disabled={loading}
                className="btn btn-primary btn-sm"
              >
                Mentés
              </button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setEditContent(comment.content);
                }}
                disabled={loading}
                className="btn btn-outline btn-sm"
              >
                Mégse
              </button>
            </div>
          </div>
        ) : (
          <p className="comment-content">{comment.content}</p>
        )}
      </div>
    </div>
  );
};

export default Comment;
